import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from "react-helmet";
//import PkCreation from 'pages/PKCreation/Tabs/CreatePk';
//import EditPk from 'pages/PKCreation/Tabs/EditPk';
import PKCreationTabs from 'pages/PKCreation/PKCreationSteps/PKCreationTabs';
import './style.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Footer from 'components/Footer/Footer';

import home from 'Assets/home.svg';
import { local_routes } from 'utils/Routes';
import { org_friendly_url, org_name, owner_perms, user_access_level } from 'Api/Api';
// import ReactTooltip from 'react-tooltip';
// eslint-disable-next-line
var createPkStatus=createPkStatus

class PKCreation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            received_source_info: {}
            //create_or_edit: null,
            //recFriendlyUrl:{},
            //showAsCreate: true
        };
        console.log("PKCreation constructor",props);

        if (props.location.data && props.location.data['source']) {
            this.state.received_source_info = props.location.data['source'];
        }
        
        this.workspace_base_url = "";
        this.workspace_indicator = '';
        if (org_friendly_url) {
            this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
            this.workspace_indicator = <span data-tip="Want to create public presentations? Switch to Public View in upper right" style={{ verticalAlign: 'text-top', fontSize: "small" }} >&nbsp;&bull;&nbsp;{org_name} View</span>;
        } else {
            if (user_access_level === 'admin' || owner_perms.organizations) {
                this.workspace_indicator = <span data-tip="Want to create private presentations? Switch to Team View in upper right" style={{ verticalAlign: 'text-top', fontSize: "small" }} >&nbsp;&bull;&nbsp;Public View</span>;
            }
        }
    }

    componentDidUpdate (prevProps) {
        //console.log("YO",prevProps);
        let { location: { pathname } } = this.props;

        if (prevProps.location.pathname === pathname) return;
        this.routeChanged();
    }

    routeChanged () {
        console.log("routeChanged PKCreation");
        this.forceUpdate();
        //this.APIPromises();
    }
    
    goToMyPresentations = () => {
        this.props.history.push(`${this.workspace_base_url}${local_routes.pklist}`);
    }
    
    render() {
        //console.log("PKCreation render",this.props);
        //let showAsCreate = this.state.showAsCreate;
        let header_text = "";
        if (this.props.match.params.entity_uuid) {
            //header_text = "PK Create"+<span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> BETA</span>+": Edit Presentation";
            header_text = <React.Fragment>PK Create<span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> BETA</span>: Edit Presentation</React.Fragment>;
            //showAsCreate = false;
        } else {
            header_text = <React.Fragment>PK Create<span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> BETA</span>: New Presentation</React.Fragment>;
        }
        
        return (
            <React.Fragment>
                <Helmet>
                    <title>PK Create: Presentation Software</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
                <React.Fragment>
                    <Container>
                        <div className="pk-Creation">

                            {createPkStatus !== false &&
                            // <div className="col-sm-12">
                              <React.Fragment>
                                <Row style={{ marginTop: "20px", marginBottom: "25px" }} className="justify-content-between">
                                    {/*<h2 style={{ fontWeight: '600', display: 'inline' }}>{header_text}</h2>{this.workspace_indicator}*/}
                                    <Col xs={8}>
                                        <h2 style={{ fontWeight: '600', display: 'inline' }}>{header_text}</h2>{this.workspace_indicator}
                                        {/*<span style={{ fontWeight: '600' }}>{header_text}</span>{this.workspace_indicator}*/}
                                    </Col>
                                    <Col xs={4} style={{ fontSize: "smaller", cursor: "pointer" }} className="flex justify-content-end" onClick={() => this.goToMyPresentations()}>
                                        <span style={{ display: 'inline' }}><i className="fa fa-angle-double-right"></i> Go to My Presentations</span>
                                    </Col>
                                    
                                </Row>
                              </React.Fragment>
                            }
                            <div className="col-sm-12">
                                <div>
                                    <PKCreationTabs
                                        received_props={this.props.match.params}
                                        received_source_info={this.state.received_source_info}
                                    />
                                </div>
                            </div>
                        </div>
                    </Container>
                    <Footer
                    homeImg={home}
                    homeImgRef={this.workspace_base_url ? this.workspace_base_url : "/"}
                    breadcrumbSubPage="PK Create"/>
                </React.Fragment>
            </React.Fragment>
        );
    }
}
 
export default withRouter(PKCreation);